var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('upcoming-event')],1),_c('v-flex',{attrs:{"xs12":""}},[_c('related-networks',{staticClass:"panelBlock",attrs:{"can-view-sub-networks":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }